// extracted by mini-css-extract-plugin
module.exports = {"version":"style_version__1jYT9","textVersion":"style_textVersion__2fXr4"};